import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { BasketsFacade } from '@kion/data-access/data-access-baskets';
import { map } from 'rxjs/operators';
import { Basket } from '@kion/data-models';
import { Observable } from 'rxjs';
// tslint:disable-next-line:nx-enforce-module-boundaries
import { CmsConfig } from '../../../../../cms/src/lib/config/cms.config';
import { ActivatedRoute } from '@angular/router';
import { SubSink } from 'subsink';

@Component({
  selector: 'kion-header-buttons',
  templateUrl: './header-buttons.component.html',
  styleUrls: ['./header-buttons.component.scss']
})
export class HeaderButtonsComponent implements OnInit, OnDestroy {

  badge$: Observable<number>;
  isCheckout: boolean;
  readonly basketRoute: string;

  subSink: SubSink;

  searchVisible: boolean;

  showMiniBasketContainer = false;

  @Output('searchClicked') searchClickedEmitter: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    private basketsFacade: BasketsFacade,
    private cmsConfig: CmsConfig,
    private route: ActivatedRoute
  ) {
    this.subSink = new SubSink();
    this.basketRoute = '/' + this.cmsConfig.routes?.basketBaseRoute;
    this.subSink.sink = this.route.data.subscribe(
      data => {
        if (data.checkout) {
          this.isCheckout = true
        }
      }
    );
  }

  ngOnInit(): void {
    this.basketsFacade.createOrFindBasket();
    this.searchVisible = false;
    this.badge$ = this.basketsFacade.all$.pipe(
      map(
        (baskets: Basket[]) => baskets.find(
          (basket: Basket) => basket.id === window.localStorage.getItem('basketId')
        )
      ),
      map(
        (basket: Basket) => {
          if (basket) {
            return basket.totalUnitCount
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  toggleSearch(): void {
    this.searchVisible = !this.searchVisible;
    this.searchClickedEmitter.emit();
  }

  toggleMiniBasketView() {
    this.showMiniBasketContainer = !this.showMiniBasketContainer;
  }
}
